module.exports = __webpack_public_path__ + "static/media/Stanley Lei.24a6498c.png";